import { render, staticRenderFns } from "./ChoseZhouShu.vue?vue&type=template&id=421e59bf&"
import script from "./ChoseZhouShu.vue?vue&type=script&lang=js&"
export * from "./ChoseZhouShu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports